import defaultPosition from "@/helpers/wc/positionSettings";

export const statisticsSettings = {
  title: "Statistics",
  name: "statisticsBase",

  styles: defaultPosition,

  properties: {
    type: 1,
    period: 1,
    targetId: 0,
    css: {
      text: {
        fontFamily: "Arial",
        fontSize: 14,
        textAlign: 'center',
        color: 'white',
        backgroundColor: 'limegreen',
        borderColor: 'grey',
        borderRadius: '5px'
      }
    }
  },
  cssLegend: {
    text: {
      name: 'wcText',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      textAlign: {
        type: 'align',
        name: 'textAlign'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'background'
      },
      borderColor: {
        type: 'color',
        name: 'borderColor'
      },
      borderRadius: {
        type: 'int',
        name: 'borderRadius',
        handler: val => val + 'px'
      }
    }
  }
};

export const StatTypes = {
  totalVisitors: 1,
  activeVisitors: 2,
  avgVisitorTime: 3,

  historyTotalVisitors: 7,
  historyAvgTime: 8,

  queueTotalVisitors: 20,
  queueLength: 21,
  queueAvgTime: 22,
  queueCurrentVisitor: 23,
  queueNextVisitor: 24,
};

export const StatPeriod = {
  yesterday: 1,
  lastWeek: 2,
  lastMonth: 3,
};
